export const TONAL_OFFSET_LIGHT = 0.2;
export const TONAL_OFFSET_DARK = 0.3;
export const TEXT_SECONDARY_ALPHA = 0.6;
export const TEXT_PLACEHOLDER_ALPHA = 0.5;
export const TEXT_DISABLED_ALPHA = 0.38;
export const STEPPER_SECONDARY_ALPHA = 0.4;
export const STATE_HOVER_ALPHA = 0.04;
export const STATE_SELECTED_ALPHA = 0.08;
export const STATE_FOCUS_ALPHA = 0.12;
export const STATE_FOCUS_VISIBLE_ALPHA = 0.3;
export const STATE_OUTLINED_BORDER_ALPHA = 0.5;
